// Conversion settings: the only place the WhatsApp number and booking link live.
// Components read from here; do not hard-code either value elsewhere.

// WhatsApp number in international format, digits only (no "+", spaces or dashes).
export const WHATSAPP_NUMBER = '971585833216'

// Where "Book a 20-min call" goes (Calendly event type).
export const BOOKING_URL = 'https://calendly.com/egmaalouf/quickcall'

// New strings for these two features. Arabic wording is a first draft and
// should be reviewed by a native speaker.
export const CONVERSION_COPY = {
  en: {
    bookCall: 'Book a 20-min call',
    whatsappLabel: 'Chat on WhatsApp',
    whatsappMessage: 'Hello Maalouf & Partners, I would like to discuss a project.'
  },
  ar: {
    bookCall: 'احجز مكالمة لمدة 20 دقيقة',
    whatsappLabel: 'تواصل عبر واتساب',
    whatsappMessage: 'مرحباً معلوف وشركاؤه، أودّ مناقشة مشروع.'
  }
}

/** wa.me link for a locale, with the message prefilled. */
export function whatsappUrl (locale) {
  const copy = CONVERSION_COPY[locale] || CONVERSION_COPY.en
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(copy.whatsappMessage)}`
}
